module.exports = __webpack_public_path__ + "img/iphone-charging-NETHERLANDS-nl.16c74207.webp";